export default __webpack_public_path__ + "6fdf0ac577be0ba82a4c9a89b8eef91b.woff";